
import { sortBy } from 'lodash';
import { Component, Emit, InjectReactive, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class';

import SetLocation from '@/components/SetLocation.vue';
import SingleLocation from '@/components/SingleLocation.vue';
import { OrderMethods } from '@/enums';
import UserModule from '@/store/modules/user';

@Component({
  components: {
    SingleLocation,
    SetLocation,
  }
})
export default class Locations extends Vue {
    @Action fetchRestaurants: () => void;
    @Getter allRestaurants!: Restaurant[];
    @Getter activeRestaurant!: Restaurant;
    @InjectReactive() viewContainerRef!: any;

    @Prop({ type: String, default: '' }) currentOrderMethod: OrderMethods;
    @Prop({ type: Boolean, default: false }) isEditMode: boolean;
    showAllClicked: boolean;

    data() {
      return {
        showAllClicked: false,
      }
    }

    async showAllLocations() {
      this.showAllClicked = true;
      const loader = this.$loading.show();
      try {
        if (this.viewContainerRef) {
          this.$scrollTo(this.viewContainerRef as Element);
        }

        await this.fetchRestaurants();

        this.$nextTick(() => {
          this.$emit('map:fit-to-bounds', true);
        });
      } catch (ex) {
      } finally {
        loader.hide();
      }
    }

    get favoriteStores() {
      return sortBy(UserModule.favoriteRestaurants, ['isDefault']).reverse();
    }

    isFavorite(id) {
      return this.favoriteStores?.find((s) => s.id === id);
    }

    get sortedRestaurants() {
      let useRestaurants = this.allRestaurants?.length ? this.allRestaurants : UserModule.favoriteRestaurants;
      useRestaurants = useRestaurants.map((r: any) => {
        const fav = this.isFavorite(r.id);
        if (fav) {
          r.isFavorite = true;
        }
        return r;
      })
      return sortBy((useRestaurants || []), ['isFavorite', 'distanceFromUser', 'name']);
    }

    get isLoggedIn() {
      return UserModule.loggedIn;
    }

    @Emit('preview-location')
    showLocation(location) {
      if (this.viewContainerRef) {
        this.$scrollTo(this.viewContainerRef as Element);
      }
      return location;
    }

    @Emit('set-location')
    selectedLocation(location) {
      if (this.viewContainerRef) {
        this.$scrollTo(this.viewContainerRef as Element);
      }
      return location;
    }
}
